import AttackBoxCard from 'src/images/svgs/virtual-environment/attackbox-card.svg';
import CompleteCard from 'src/images/svgs/virtual-environment/complete-card.svg';
import TargetMachineCard from 'src/images/svgs/virtual-environment/target-machine-card.svg';

export const editorTemplates = [
  {
    title: 'Machine Button',
    description: 'Adds a machine button placeholder',
    content: '<!-- START-MACHINE BUTTON -->\n<div id="task-cta-{task number}">START MACHINE</div>',
  },
  {
    title: 'Centered Image',
    description: 'Adds a centered image with alt text',
    content:
      '<p style="text-align:center"><img alt="alternate text" src="https://tryhackme-images.s3.amazonaws.com/user-uploads/66b36e2379a5d0220fc6b99e/room-content/66b36e2379a5d0220fc6b99e-1728655416943.png"></p>',
  },
  {
    title: 'Terminal Container',
    description: 'Adds a terminal container with PowerShell styling',
    content:
      '<div class="terminal-container">\n  <div class="terminal-content defender">\n    <div class="terminal-top">Terminal</div>\n    <pre class="terminal-code">\n      <code class="language-powershell">user@machine$ --command-- --output--</code>\n    </pre>\n  </div>\n</div>\n<p></p>',
  },
  {
    title: 'Collapsible Image Section',
    description: 'Adds a collapsible section containing an image',
    content:
      '<details>\n  <summary>See image</summary>\n  <div style="text-align:center">\n    <img src="https://tryhackme-images.s3.amazonaws.com/user-uploads/66b36e2379a5d0220fc6b99e/room-content/66b36e2379a5d0220fc6b99e-1728655416943.png">\n    <br>\n  </div>\n</details>\n<p></p>',
  },
  {
    title: 'Credentials Card',
    description: 'Adds a styled credentials card with username, password, and IP address and connection via ssh/rdp',
    content: `<div class="credentials-card">
      <p class="credentials-card-title">Credentials</p>
      <p class="credentials-card-subtitle">Only needed if you are using your own machine.</p>

      <div class="credentials-card-container">
        <!-- Username -->
        <div class="credentials-card-item">
          <div class="credentials-card-label">Username</div>
          <div class="credentials-card-value-container">
            <div class="credentials-icon credentials-icon-user"></div>
            <div class="copy-wrapper" style="display: inline-flex; align-items: center;">
              <span class="credentials-card-value">Administrator</span>
              <button class="copy-button"></button>
              <div class="tooltip"></div>
            </div>
          </div>
        </div>

        <!-- Password -->
        <div class="credentials-card-item password">
          <div class="credentials-card-label">Password</div>
          <div class="credentials-card-value-container">
            <div class="credentials-icon credentials-icon-password"></div>
            <div class="copy-wrapper" style="display: inline-flex; align-items: center;">
              <span class="credentials-card-value">Whiterose1</span>
              <button class="copy-button"></button>
              <div class="tooltip"></div>
            </div>
          </div>
        </div>

        <!-- IP Address -->
        <div class="credentials-card-item ip">
          <div class="credentials-card-label">IP address</div>
          <div class="credentials-card-value-container">
            <div class="credentials-icon credentials-icon-ip"></div>
            <div class="copy-wrapper" style="display: inline-flex; align-items: center;">
              <span class="credentials-card-value">10.10.777.99</span>
              <button class="copy-button"></button>
              <div class="tooltip"></div>
            </div>
          </div>
        </div>

        <!-- Connection Via SSH-->
        <div class="credentials-card-item connection">
          <div class="credentials-card-label">Connection via</div>
          <div class="credentials-card-value-container">
            <div class="credentials-icon credentials-icon-connection"></div>
            <span class="credentials-card-value">SSH</span>
            <div class="copy-wrapper" style="display: inline-flex; align-items: center;">
              <div class="credentials-connection-code">
                <span class="credentials-connection-command">ssh whiterose@&lt;Target IP&gt;</span>
              </div>
              <button class="copy-button"></button>
              <div class="tooltip"></div>
            </div>
          </div>
        </div>
      </div>
    </div>`,
  },
  {
    title: 'AttackBox only',
    description: 'Adds an AttackBox card placeholder',
    content: `<div class="attackbox"><!-- PLACEHOLDER ONLY -->\n<img alt="AttackBox card placeholder" src="${AttackBoxCard}" /></div>`,
  },
  {
    title: 'Target Machine only',
    description: 'Adds a Target Machine card placeholder',
    content: `<div class="target-machine"><!-- PLACEHOLDER ONLY -->\n<img alt="Target Machine card placeholder" src="${TargetMachineCard}" /></div>`,
  },
  {
    title: 'AttackBox + Target Machine',
    description: 'Adds a Virtual Environment card placeholder',
    content: `<div class="virtual-environment"><!-- PLACEHOLDER ONLY -->\n<img alt="Virtual Environment card placeholder" src="${CompleteCard}" /></div>`,
  },
];
